import { Box, Transition } from '@mantine/core';
import { forwardRef } from 'react';
import { useReducedMotion } from '../hooks';

export interface ZoomInProps {
  children: React.ReactNode;
  visible?: boolean;
  duration?: number;
  delay?: number;
  initialScale?: number;
  timingFunction?: string;
  onEnter?: () => void;
  onEntered?: () => void;
  onExit?: () => void;
  onExited?: () => void;
}

const ZoomIn = forwardRef<HTMLDivElement, ZoomInProps>(
  (
    {
      children,
      visible = true,
      duration = 300,
      delay = 0,
      initialScale = 0,
      timingFunction = 'cubic-bezier(0.34, 1.56, 0.64, 1)',
      onEnter,
      onEntered,
      onExit,
      onExited,
    },
    ref
  ) => {
    const reducedMotion = useReducedMotion();
    const actualDuration = reducedMotion ? 0 : duration;

    const zoomTransition = {
      in: { opacity: 1, transform: 'scale(1)' },
      out: { opacity: 0, transform: `scale(${initialScale})` },
      common: { transformOrigin: 'center center' },
      transitionProperty: 'opacity, transform',
    };

    return (
      <Transition
        mounted={visible}
        transition={zoomTransition}
        duration={actualDuration}
        timingFunction={timingFunction}
        onEnter={onEnter}
        onEntered={onEntered}
        onExit={onExit}
        onExited={onExited}
      >
        {(styles) => (
          <Box
            ref={ref}
            style={{
              ...styles,
              transitionDelay: `${delay}ms`,
            }}
          >
            {children}
          </Box>
        )}
      </Transition>
    );
  }
);

ZoomIn.displayName = 'ZoomIn';

export default ZoomIn;
